/*
 * Кнопка ⓘ и поповер объяснения (docs/release-2026-09-19.md §1).
 *
 * Геометрия поповера — `.tip` органов шапки (`WriterModelSwitch.module.css`) дословно:
 * ширина 300, поля 12/14, радиус контрола, тень `--sh-float`, 12.5/1.45 цветом `--ink-2`.
 * Два вида подсказок одной формы читаются как один механизм «здесь объясняют», а
 * расходящиеся шириной и отступом — как два разных.
 */

.wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: none;
  vertical-align: middle;
}

/* Кружок 20px — тише чипов рядом: объяснение не спорит с действием за внимание. */
.btn {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: var(--r-pill);
  background: var(--white);
  color: var(--muted);
  cursor: pointer;
  transition:
    color 0.12s var(--ease),
    border-color 0.12s var(--ease);
}
.btn:hover,
.btnOn {
  color: var(--accent-ink);
  border-color: var(--violet-bg-2);
}

.pop {
  position: fixed;
  z-index: 60;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border-radius: var(--r-ctl);
  background: var(--white);
  border: 1px solid var(--border);
  box-shadow: var(--sh-float);
  font-size: 12.5px;
  font-weight: 400;
  line-height: 1.45;
  letter-spacing: normal;
  text-transform: none;
  color: var(--ink-2);
  text-align: left;
  white-space: normal;
}
.pop b {
  font-size: 13px;
  color: var(--ink);
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
